import { toast } from 'sonner';

// Abas de preços da Formação Revit Expert.
export const PRICING_TABS = [
  { value: 'ead_recorded', label: 'EaD Gravado', sub: 'On-demand', base: 'ead_recorded', discount: 0, kind: 'ead', color: 'red', category: 'padrao' },
  { value: 'ead_live', label: 'Elite', sub: 'Ao Vivo', base: 'ead_live', discount: 0, kind: 'live', color: 'red', category: 'padrao' },
  { value: 'presential', label: 'Mentor', sub: 'Mentoria Exclusiva', base: 'presential', discount: 0, kind: 'mentor', color: 'red', category: 'padrao' },
  { value: 'conselhos_ead', label: 'EaD Gravado', sub: '-50% EaD', base: 'ead_recorded', discount: 0.5, kind: 'ead', color: 'teal', noteType: 'conselhos', category: 'conselhos', parcela: 610.33 },
  { value: 'conselhos_elite', label: 'Elite', sub: '-20% Ao Vivo', base: 'ead_live', discount: 0.2, kind: 'live', color: 'teal', noteType: 'conselhos', category: 'conselhos', parcela: 820.28 },
  { value: 'conselhos_mentor', label: 'Mentor', sub: '-20% Mentor', base: 'presential', discount: 0.2, kind: 'mentor', color: 'teal', noteType: 'conselhos', category: 'conselhos', parcela: 2144.00 },
  { value: 'estudantes_ead', label: 'EaD Gravado', sub: '-60% EaD', base: 'ead_recorded', discount: 0.6, kind: 'ead', color: 'blue', noteType: 'estudantes', category: 'estudantes', parcela: 488.00 },
  { value: 'estudantes_conv_ead', label: 'EaD Gravado (Faculdades Conveniadas)', sub: '-70% EaD', base: 'ead_recorded', discount: 0.7, kind: 'ead', color: 'blue', noteType: 'estudantes', category: 'estudantes', parcela: 366.20 },
  { value: 'estudantes_elite', label: 'Elite', sub: '-60% Ao Vivo', base: 'ead_live', discount: 0.6, kind: 'live', color: 'blue', noteType: 'estudantes', category: 'estudantes', parcela: 410.14 },
  { value: 'estudantes_conv_elite', label: 'Elite (Faculdades Conveniadas)', sub: '-70% Ao Vivo', base: 'ead_live', discount: 0.7, kind: 'live', color: 'blue', noteType: 'estudantes', category: 'estudantes', parcela: 307.60 }
];

// Parcelamento e formas de pagamento por modalidade (kind).
export const PAYMENT_INFO = {
  ead:    { count: 12, value: 1220.00,  methods: 'PayPal ou cartão de crédito' },
  live:   { count: 20, value: 1025.36,  methods: 'PayPal, Pix ou cartão de crédito recorrente' },
  mentor: { count: 20, value: 2680.00,  methods: 'PayPal, Pix ou cartão de crédito recorrente' }
};

// Formações específicas (não a Expert id=6) com preço EaD Gravado exclusivo e descontos.
export const SPECIFIC_BUNDLE_PRICING = {
  1: { eadOnly: true, count: 12, methods: 'PayPal ou cartão de crédito' },
  2: { eadOnly: true, count: 12, methods: 'PayPal ou cartão de crédito' },
  3: { eadOnly: true, count: 12, methods: 'PayPal ou cartão de crédito' },
  4: { eadOnly: false, count: 12, methods: 'PayPal ou cartão de crédito' },
  5: { eadOnly: false, count: 12, methods: 'PayPal ou cartão de crédito' }
};

// Faixas de desconto aplicadas sobre o preço-base EaD Gravado.
export const SPECIFIC_DISCOUNTS = [
  { label: 'Conselhos, associações e sindicatos', off: 50, factor: 0.5, color: 'text-teal-300' },
  { label: 'Estudantes', off: 60, factor: 0.4, color: 'text-blue-300' },
  { label: 'Estudantes (faculdades conveniadas)', off: 70, factor: 0.3, color: 'text-blue-300' }
];

export const TAB_CATEGORIES = [
  { key: 'padrao', label: 'Padrão' },
  { key: 'conselhos', label: 'Conselhos Conveniados' },
  { key: 'estudantes', label: 'Estudantes' }
];

// E-mail para matrícula com comprovação de vínculo (condições com desconto).
export const ENROLLMENT_EMAIL = 'comercial@bimportal.com.br';

export const TAB_ACTIVE_COLOR = {
  red: 'data-[state=active]:bg-red-600',
  teal: 'data-[state=active]:bg-teal-600',
  blue: 'data-[state=active]:bg-blue-600'
};

export const openHotmart = (offer) => {
  if (!offer) return;
  const win = window.open(`https://pay.hotmart.com/${offer}`, '_blank', 'noopener');
  if (!win) toast.error('Não foi possível abrir o checkout. Verifique o bloqueador de pop-ups.');
};
